import TextButton from './TextButton'

const DropdownButton = ({ onClick, children }) => (
    <TextButton className="nav-user-dropdown-button" onClick={onClick}>
        {children}
    </TextButton>
)

export default DropdownButton
